const PieColors = [
  "#F06A8A",
  "#8FBDDF",
  "#FAE360",
  "#dddddd",
  "#F48E35"
];

export { PieColors }
